import { ConfigParamsService } from '../../services/configParameters/config-params.service';
import { LoginService } from '../../services/login/login.service';
import { UrlParamService } from '../../services/utils/url-param.service';

import { Component, OnInit } from '@angular/core';
import { EditionLayer } from '../../models/edition-layer';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '@ngx-translate/core';
import { MatSidenav } from '@angular/material';
@Component({
  selector: 'app-gisweb',
  templateUrl: './gisweb.component.html',
  styleUrls: ['./gisweb.component.css'],
})
export class GisWebComponent implements OnInit {

  sidenavReference: MatSidenav;
  subscription: Subscription;
  public isPrivateApp: boolean;
  public showTornarEndarrera: number = -1;
  public menuOpen: Boolean = false;
  public moveMapToExtent: number = -1;
  public newThematic = 'fons';
  public showGeolocation: number = -1;
  public listEstats = [];
  public editionLayerSelected: EditionLayer = null;
  public editionFeatureSelected: object = null;
  public layerTitle_edition = "";
  public refreshMap = false;
  private modificarPosicioFeature = {};
  private config: any;
  public hiddenPanels = {
    layergrid: false,
    menu: true,
    map: true,
    editionpanel: true
  };

  public options = {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true
  };

  protected isSideNavOpen = false;

  constructor(
    private urlParamsService: UrlParamService,
    protected configParamsService: ConfigParamsService,
    loginService: LoginService,
    private router: Router,
    private translateService: TranslateService  ) {
    if (!loginService.checkLogin() && this.configParamsService.isPrivateApp()) {
      this.router.navigate(['/privat']);
    }
    console.debug(' >>> VisorComponent: constructor');
    this.config = this.configParamsService.getConfig();
    if (!this.config) {
      this.configParamsService.getConfigFile('global').then(data => {
        this.config = data;
        if(this.config.lang && this.translateService.getLangs().indexOf(this.config.lang) >= 0){
          this.translateService.use(this.config.lang)
        }        
      });
    }
    this.subscription = this.configParamsService.getSelectedEditionLayer().subscribe(editionLayer => {
      this.layerToEditHandle(editionLayer);
      this.editionLayerSelected = editionLayer;
      this.layerTitle_edition = editionLayer["nom_capa"];
    })
  }

  ngOnInit() {
    console.debug(' >>> VisorComponent: ngOnInit');
    const params = window.location.search.substring(1).split('&');
    params.forEach(value => {
      const pair = value.split(/=(.+)?/);
      this.urlParamsService.setParam(pair[0], pair[1]);
    });
  }

  private toggleMap() {
    //si el mapa està amagat:

    if (this.hiddenPanels.map) {
      this.showTornarEndarrera = new Date().getTime();
      this.hiddenPanels.layergrid = true;
      this.hiddenPanels.editionpanel = true;
      //el mapa i el menu van junts.
      this.hiddenPanels.menu = false;
      this.hiddenPanels.map = false;
      this.refreshMap = true;
    } else {
      this.refreshMap = false;
      this.hiddenPanels.map = true;
    }
  }



  public mapZoomToExtentEventHandler(event: number) {
    this.moveMapToExtent = event;
  }




  /*
  * -------------------------------------------------
  * Mostra el panell d'edició de features (buit o ple)
  * -------------------------------------------------
  */
  private toggleShowEditionPanel() {
    //Amagem el mapa
    this.hiddenPanels.map = true;
    this.refreshMap = false;
    //Amagem el layer grid
    this.hiddenPanels.layergrid = true;
    //Mostrem el panell d'edició i el botó de tornar enrera
    this.hiddenPanels.editionpanel = false;

  }


  public showGeolocationHandler(event: number) {
    console.log("showGeolocationHandler", event);
    this.showGeolocation = event;
  }


  /*
  * -------------------------------------------------
  * Mostra el panell d'edició omplert amb les dades del feature
  * -------------------------------------------------
  */
  public showFeatureEditionPanelHandler(event) {
    this.toggleShowEditionPanel();
    this.editionFeatureSelected = event;
  }

  /*
  * -------------------------------------------------
  * Mostra el mapa amb tots els features que es poden editar.
  * -------------------------------------------------
  */
  public layerToEditHandle(event: EditionLayer) {
    this.toggleMap();
    this.editionLayerSelected = event;
  }

  public modificarPosicioHandler(event) {
    this.modificarPosicioFeature = event;
    this.hiddenPanels.editionpanel = true;
    //el mapa i el menu van junts.    
    this.hiddenPanels.map = false;
    this.hiddenPanels.menu = false;
    this.refreshMap = false;
  }

  public goBack() {
    if (!this.hiddenPanels.map && !this.isSideNavOpen) {
      this.layerTitle_edition = 'Edició GIS';
      this.showTornarEndarrera = -1;
      this.hiddenPanels.map = true;
      this.hiddenPanels.menu = true;
      this.hiddenPanels.editionpanel = true;
      this.hiddenPanels.layergrid = false;
      if (!this.configParamsService.isPrivateApp()) {
        this.router.navigate(['/public']);
        return;
      }
    } else if (!this.hiddenPanels.editionpanel || this.isSideNavOpen) {
      this.showTornarEndarrera = new Date().getTime();
      this.hiddenPanels.editionpanel = true;
      this.hiddenPanels.layergrid = true;
      this.hiddenPanels.map = false;
      this.hiddenPanels.menu = false;
      this.refreshMap = false;
    }

    if (this.sidenavReference && this.sidenavReference.opened) {
      this.sidenavReference.close();
      this.isSideNavOpen = false;
    }
  }

  public setSidenav(sidenav: MatSidenav) {
    this.sidenavReference = sidenav;
  }

}




// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/gisweb/gisweb.component.ts